/**
 * Authentification service.
 * Performs api calls sending the required authentication headers.
 * Check and validate tokens
 * Perfom login and logout of the user
 */
import decode from 'jwt-decode';
import { API_BASE_URL, ACCESS_TOKEN, REFRESH_TOKEN } from './constants';

/**
 * User login
 * Get a token from api server using the fetch api
 * @param {String} username
 * @param {String} password
 * @return {Promise}
 */
export function	login(username, password) {
		return fetch(API_BASE_URL + '/oauth2/login', {
			headers: new Headers({
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}),
			method: 'POST',
			body: JSON.stringify({
				username,
				password
			})
		})
		.then(checkResponceStatus)
		.then(response => {
			return response.json();
		})
	}

/**
 * Registration new user
 * @param {String} username
 * @param {String} password
 * @return {Promise}
 */
export function signup(username, password) {
		return fetch(API_BASE_URL + '/users/user/register', {
			headers: new Headers({
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}),
			method: 'POST',
			body: JSON.stringify({
				login: username,
				email: username,
				password
			})
		})
		.then(checkResponceStatus)
		.then(response => response.json())
	}

/**
 * Confirmation new user registration
 * @param {String} token
 * @return {Promise}
 */
export function confirmate(token) {
	return fetch(API_BASE_URL + '/users/registrationConfirm/' + token, {
		headers: new Headers({
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		}),
		method: 'GET'
	})
		.then(checkResponceStatus)
		.then(response => response.json())
}

/**
 * Send email to recover a password
 * @param {String} email
 * @return {Promise}
 */
export function recover(email) {
	return fetch(API_BASE_URL + '/users/sendRecoverEmail' + `?email=${email}`, {
		headers: new Headers({
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		}),
		method: 'GET'
	})
		.then(checkResponceStatus)
		.then(response => response.json())
}

/**
 * Reset password by admin reason
 * @param{Object} user credentials email && newPassword
 * @return {Promise}
 */

export function resetPassword(credentials) {
	return secureFetch(API_BASE_URL + '/users/resetPassword', {
		method: 'POST',
		body: JSON.stringify(credentials)
	})
}

/**
 * Send new password to update
 * @param {Object} credentials
 * @return {Promise}
 */
export function passwdUpdate(credentials) {
	return fetch(API_BASE_URL + '/users/updatePassword', {
		headers: new Headers({
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		}),
		method: 'POST',
			body: JSON.stringify(credentials)
	})
		.then(checkResponceStatus)
		.then(response => response.json())
}

/**
 * Check Login if exist
 * @param {String} login
 * @return {Promise}
 */
export function	checkLogin(login) {
		return fetch(`${API_BASE_URL}/users/checkEmailAvailability?email=${login}`, {
			headers: new Headers({
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}),
			method: 'GET'
		})
		.then(checkResponceStatus)
		.then(response => response.json())
	}

/**
 * Checks if there is a saved token and it's still valid
 * If no, is trying to get a new one
 * @return {Promise} with true or false result
 */
export function loggedIn() {
			const token = getToken(); // Getting token from localstorage
			const refToken = getRefreshToken(); // Getting refresh token from localstorage
			if (typeof token === 'undefined' || typeof refToken === 'undefined') {
				return Promise.resolve(false);
			}
			if (!token || !refToken) {
				return Promise.resolve(false);
			}
			if (token) {
				return Promise.resolve(true);
			} else {
				console.log('token', token)
				// refreshToken().then(res => {
				// 	return true;
				// }, () => {
				// 	return false;
				// })
				return Promise.resolve(false);
			}
	}

export function	setToken(accessToken, refreshToken) {
		// Saves user token to localStorage
		localStorage.setItem(ACCESS_TOKEN, accessToken);
		localStorage.setItem(REFRESH_TOKEN, refreshToken);
	}

export function	getToken() {
		// Retrieves the user token from localStorage
		return localStorage.getItem(ACCESS_TOKEN)
	}

export function	getRefreshToken() {
		// Retrieves the user token from localStorage
		return localStorage.getItem(REFRESH_TOKEN)
	}

export function	logout() {
		// Clear user token and profile data from localStorage
		localStorage.removeItem(ACCESS_TOKEN);
		localStorage.removeItem(REFRESH_TOKEN);
	}

export function	getProfile() {
		// Using jwt-decode npm package to decode the token
	try {
		return decode(getToken());
	} catch (err) {
		console.error(err);
		return false;
	}
}

const refreshToken = () => {
	return fetchJSONWithToken(API_BASE_URL + '/oauth2/refresh', {
		method: 'POST',
		body: JSON.stringify({
			refreshToken: getRefreshToken()
		})
	})
		.then(response => {
			setToken(response.accessToken, response.refreshToken);
			return response;
		})
		.catch(error => {
			// Clear token and continue with the Promise catch chain
			console.error('can not update refresh token', error)
			logout();
			throw error
		})
};

const shouldRefreshToken = error => {
	console.error('should refresh token');
	if (error && error.status) {
		return error.response.status === 401;
	} else {
		return true;
	}
};

const fetchJSONWithToken = (url, options, addHeaders) => {
	let headers = null;
	if (addHeaders) {
		//headers[addHeader.name] = addHeader.value;
		headers = addHeaders;
	} else {
		headers = {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		}
	}
	headers['Authorization'] = 'Bearer ' + getToken();
	return fetchJSON(url, {
		headers,
		...options
	}).then(res => {
		return res.body;
	});
};

export const secureFetch = configureRefreshFetch({
	shouldRefreshToken,
	refreshToken,
	fetch: fetchJSONWithToken,
});

export const secureDownload = async (url, options, addHeaders) => {
	let headers = null;
	if (addHeaders) {
		//headers[addHeader.name] = addHeader.value;
		headers = addHeaders;
	} else {
		headers = {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		}
	}
	headers['Authorization'] = 'Bearer ' + getToken();
	let res = await fetch(url, {
		headers,
		...options
	});
	if (res.status === 401) {
		if (await refreshToken()) {
			headers['Authorization'] = 'Bearer ' + getToken();
			res = await fetch(url, {
				headers,
				...options
			});
		}
	}
	if (res.status >= 200 && res.status < 300) {
		let filename = 'statistic';
		const disposition = res.headers.get('content-disposition');
		const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
		const matches = filenameRegex.exec(disposition);
		if (matches != null && matches[1]) {
			filename = matches[1].replace(/['"]/g, '');
		}
		let file = await res.blob();
		return {file: file, fileName: filename}
	} else {
		const error = new Error(res.statusText);
		error.res = res;
		throw error
	}
};

export function	checkResponceStatus(response) {
		// raises an error in case response status is not a success
		if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
			return response
		} else {
			const error = new Error(response.statusText);
			error.response = response;
			throw error
		}
}


/* vendor functions*/
function configureRefreshFetch(configuration) {
    var refreshToken = configuration.refreshToken,
        shouldRefreshToken = configuration.shouldRefreshToken,
        fetch = configuration.fetch;
    var refreshingTokenPromise = null;
    return function (url, options, addHeaders) {
        if (refreshingTokenPromise !== null) {
            return refreshingTokenPromise.then(function () {
                return fetch(url, options, addHeaders);
            }) // Even if the refreshing fails, do the fetch so we reject with
            // error of that request
                .catch(function () {
                    return fetch(url, options, addHeaders).catch(function (error) {
                        throw error;
                    });
                });
        }

        return fetch(url, options, addHeaders).catch(function (error) {
            if (shouldRefreshToken(error)) {
                if (refreshingTokenPromise === null) {
                    refreshingTokenPromise = new Promise(function (resolve, reject) {
                        refreshToken().then(function () {
                            refreshingTokenPromise = null;
                            resolve();
                        }).catch(function (refreshTokenError) {
                            refreshingTokenPromise = null;
                            reject(refreshTokenError);
                        });
                    });
                }

                return refreshingTokenPromise.then(function () {
                    return fetch(url, options, addHeaders);
                }).catch(function () {
                    // If refreshing fails, continue with original error
					console.error('refresh token error', error);
                    //throw error;
					return Promise.reject({
						name: 'refresh token error',
						status: 401
					});
                });
            } else {
				console.error(error.response.statusText, error);
				return Promise.reject({
					name: error.response.statusText,
					status: error.status,
					message: error.body.message
				});
            }
        });
    };
}

export function fetchJSON(url, options) {
    return fetch(url, options).then(function (response) {
        return getResponseBody(response).then(function (body) {
            return {
                response: response,
                body: body
            };
        });
    }).then(checkStatus);
};

function getResponseBody(response) {
    var contentType = response.headers.get('content-type');
    return contentType && contentType.indexOf('json') >= 0 ? response.text().then(tryParseJSON) : response.text();
};

function tryParseJSON(json) {
    if (!json) {
        return null;
    }

    try {
        return JSON.parse(json);
    } catch (e) {
        throw new Error("Failed to parse unexpected JSON response: ".concat(json));
    }
};

function ResponseError(status, response, body) {
    this.name = 'ResponseError';
    this.status = status;
    this.response = response;
    this.body = body;
} // $FlowIssue

ResponseError.prototype = Error.prototype;

function checkStatus(_ref) {
    var response = _ref.response,
        body = _ref.body;

    if (response.ok) {
        return {
            response: response,
            body: body
        };
    } else {
        throw new ResponseError(response.status, response, body);
    }
};



// WEBPACK FOOTER //
// ./src/helpers/authService.js